import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import legend from '../../images/about/lazerUygulamalari.jpg';
import kilcal from '../../images/kozmetik/16001710716615.jpg';
import lazer from '../../images/kozmetik/1600170895478.jpg';
import leke from '../../images/kozmetik/16001713555310.jpg';
import '../../styles/subItem.css'

const CiltYenileme = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='sub-page'>
            <Image src={legend} fluid className="subItemPage-img" />
            <Container>
                <Row className="mt-4">
                    <Col>
                        <h2>LAZERLE CİLT YENİLEME</h2>
                        <hr />
                        <div className='image-frame'>
                            <Image src={lazer} className='subitem-img' />
                        </div>
                        <p>Uzun yıllardan beri insanlar daha genç görünmek ve yaşlanmanın görünür etkilerini azaltmak amacıyla çeşitli cerrahi tedavi yöntemlerine başvurmaktadır. Yüz germe operasyonları bunların en yaygın örnekleridir. Sonuçta, yüz germe operasyonu ciddi bir ameliyattır ve anestezi, dokuların kesilmesi, tekrar dikilmesi, uzun iyileşme süreci, enfeksiyon riski anlamına gelmektedir. Asimetri, doğal olmayan görüntü muhtemel diğer komplikasyonlardır.</p>
                        <p>Cilt gençleştirme konusuna ilgili pek çok adayın yukarıda bahsi geçen sebeplerden dolayı cerrahi girişimleri tercih etmemesi sonucu cerrahi olmayan, iyileşme sürecinin daha kısa olduğu veya hiç olmadığı lazerle cilt yenileme ve lazerle cilt gençleştirme teknikleri geliştirilmiş ve son yıllarda giderek populerliği artmıştır. Ameliyat risklerini almadan cildin sıkılaştırılması, kırışıklıkların giderilmesi ve yerçekimi etkisi ile ciltte oluşan sarkmaların toparlanması çeşitli dokularda muazzam değişiklikler yapabilen lazer ile cilt gençleştirme teknolojileri ile mümkün olabilmektedir.</p>
                        <p>Lazerle cilt gençleştirme ve cilt yenileme işleminde kullanılan lazer cihazlarının tamamı cilde yüksek enerjili ışınlar gönderirler. Bu lazer ışınları cildin yapısında bulunan su molekülleri veya kromofor adı verilen ve renk içeren maddeler tarafından tutulurlar. Işık enerjisinin su ve kromoforlarca tutulması sonucu enerji ısıya dönüşür ve cildin ışığa maruz kalan bölgesini kontrollü olarak katmanlar halinde tahrip eder. Lazer atışlarına maruz kalma sonucu tahrip olmuş cildin güneş ve benzeri etkilerden yıpranmış ve kırışmış dış katmanlarının yerini, yeni oluşan taze cilt dokuları alır. Bazı lazerler cilt yenileme işlemini cilt dokularını tahrip etmeden sadece ısıtarak da sağlamaktadır.Lazerle cilt gençleştirme işlemi sonucunda cilt yapısı ve görüntüsünde önemli bir gelişme sağlanabilir. Cilt daha genç, daha sağlıklı, lekelerden ve izlerden arınmış daha temiz ve duru bir görünüme kavuşur. Lazerle cilt yenileme işlemi ile cildin elastikiyeti artar ve kırışıklıklar önemli oranda azalır.</p>
                    </Col>
                    <hr />
                </Row>
                <Row className='justify-content-md-start mt-3'>
                    <h2 className='mb-4'>Lazer Uygulamaları</h2>

                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/lazer-epilasyon" onClick={handleScrollToTop} >
                            <Card.Body>
                                <p>LAZER EPİLASYON</p>
                                <div className='card-image-frame'>
                                    <Image src={lazer} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/kilcal-damar-ve-varis-tedavisi" onClick={handleScrollToTop}>
                            <Card.Body>
                                <p>LAZERLE KILCAL DAMAR VE VARİS TEDAVİSİ</p>
                                <div className='card-image-frame'>
                                    <Image src={kilcal} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                        <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/leke-tedavisi" onClick={handleScrollToTop}>
                            <Card.Body>
                                <p>LAZERLE LEKE TEDAVİSİ</p>
                                <div className='card-image-frame'>
                                    <Image src={leke} rounded className='exec-summary-images2' />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    
                </Row>
            </Container>
        </div>
    )
}

export default CiltYenileme